export const permissionsKeys = {
  page: 'micro-sites.personalized-sites',
  pageBlockFind: 'micro-sites.personalized-sites.find',
  pageBlockCreate: 'micro-sites.personalized-sites.create',
  pageBlockUpdate: 'micro-sites.personalized-sites.update',
  pageBlockRemove: 'micro-sites.personalized-sites.remove',
  pageBlockUpdateInactivate: 'micro-sites.personalized-sites.inactivate',
  pageBlockUpdateActive: 'micro-sites.personalized-sites.activate',
  pageBlockDraft: 'micro-sites.personalized-sites.setDraft',
  pageGoToPage: 'micro-sites.personalized-sites.goToPage',
  pageChangeToNavigationPage: 'micro-sites.personalized-sites.changeToNavigationPage',
  pagePublish: 'micro-sites.personalized-sites.publish',
} as const;
// 0:"micro-sites"
// 1:"editor-management"
// 2:"editor-management.find"
// 3:"editor-management.create"
// 4:"editor-management.update"
// 5:"editor-management.remove"
// 6:"editor-management.manage"
export const permissionsKeysPublishers = {
  page: 'editor-management',
  pageBlockFind: 'editor-management.find',
  pageBlockCreate: 'editor-management.create',
  pageBlockUpdate: 'editor-management.update',
  pageBlockRemove: 'editor-management.remove',
  pageBlockManage: 'editor-management.manage',
} as const;
